import { DestroyRef, Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CreateCycleDialogComponent } from '@shared/components/create-cycle-dialog/create-cycle-dialog.component';
import { ProfilesSelectionGenerationComponent } from '@shared/components/profiles-selection-generation/profiles-selection-generation.component';
// import { ProfilesSelectionComponent } from '@shared/components/profiles-selection/profiles-selection.component';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { ConfigurationService } from '@shared/services/configuration.service';
import moment from 'moment';
import { BehaviorSubject, Subject } from 'rxjs';
import { HrsuiteService } from 'src/app/hrsuite/hrsuite.service';
import { ConfirmationPopupComponent } from 'src/app/shared/components/confirmation-popup/confirmation-popup.component';
import { ProfilesPickerDialogComponent } from 'src/app/shared/components/profiles-picker-dialog/profiles-picker-dialog.component';
import { cycle } from 'src/app/shared/models/cycle.model';
import { CycleWeekType } from 'src/app/shared/models/cycleWeekType.model';
import { NurseCycleEffectif } from 'src/app/shared/models/nurseCycleEffectif.model';
import { Reason } from 'src/app/shared/models/reason.model';
import { ReasonMap } from 'src/app/shared/models/reasonMap.model';
import { CycleService } from 'src/app/shared/services/cycle.service';
import { PopupManagerService } from 'src/app/shared/services/popup-manager.service';
import { ReasonService } from 'src/app/shared/services/reason.service';
import { ReasonMapService } from 'src/app/shared/services/reasonMap.service';
import { UserService } from 'src/app/shared/services/user.service';
import { escapeRegExp } from 'src/app/shared/utils/cross-functions';

import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { ABSENCE_REASONS, PRESENCE_REASONS } from '../../shared/const/absence-reasons.const';
import { ANESTHETIST, CYCLEDURATIONS, NURSE, frenchDays } from '../../shared/const/globals.const';
import { Profile } from '../../shared/models/profile.model';
import { ErrorService } from '../../shared/services/error.service';
import { ProfileService } from '../../shared/services/profile.service';
import { UtilisService } from './utilis.service';

@Injectable() //TODO: Reword this service to only have the communication with DAL
export class NurseCycleService {
  private instanceId: string;

  public cycleDuration: number | undefined = 1;

  public profilesType: string = NURSE;

  public isLoadingNewSearch: boolean = false;

  public profileList = new MatTableDataSource<Profile>();

  public weekDays: string[];

  public frenchDays: string[] = frenchDays;

  public displayedColumns: string[] = ['name', 'dates'];

  public day: moment.Moment;

  public effectif: any[] | undefined;

  public showAllRooms: boolean;

  public needs: any[] | undefined;

  public morningDiffs: number[] = [];

  public afternoonDiffs: number[] = [];

  public fromDate: string | undefined;

  public toDate: string | undefined;

  public isInfoLoading: boolean[];

  public isWaiting: boolean = false;

  public searchValue: string = '';

  public absenceReasons: string[] | undefined;

  public presenceReasons: string[] | undefined;

  public cycleDurations: number[] = CYCLEDURATIONS;

  public selectedWeek: number = 1;

  public weeks: number[] = [];

  private page: number = 1;

  private pageSize: number = 7;

  public cycle: cycle | undefined;

  public cycleNightEffectifNeeds: any;

  public endDate: Date | undefined;

  public startDate: Date | undefined;

  public cycles: cycle[] | undefined;

  public isMultiHospitals: boolean = false;

  public isCycles: boolean = true;

  public nurseCycleEffectif: NurseCycleEffectif[] | undefined;

  public anesthCycleEffectif: any[] | undefined;

  public keepOldCalendars: boolean = true;

  // subjects
  public weekSelectionChangeSubject = new BehaviorSubject<boolean>(false);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public reasonsSubject = new BehaviorSubject<Reason[]>([]);

  public reasonMapsSubject = new BehaviorSubject<ReasonMap[]>([]);

  public openEditCycleDialogSubject = new Subject<{ index: number; currentWeek: any }>();

  public isStepperClosedSubject = new Subject<boolean | void>();

  public getCycleWeekTypeSubject = new Subject<void>();

  public isLoading = this.loadingSubject.asObservable();

  public isGenerating: boolean = false;

  private interval: any;

  public progress = 0;

  public reasonsGarde: Reason[] = [];

  public reasons: Reason[] | undefined;

  public allReasons: Reason[] = [];

  public shortDates: string[] | undefined;

  public selectedDays: Date[][] | undefined;

  public hoverDay: Date[] = [];

  public type: string | undefined;

  public position: string | undefined;

  public formGroup: FormGroup | undefined;

  public isNight = false;

  private startingWeekNumber = null;

  public types = [
    {
      label: 'Supprimer et remplacer',
      value: 'false',
    },
    {
      label: 'Ajouter',
      value: 'true',
    },
  ];

  public hospitalNames: HospitalNames;

  public reasonsMaps: ReasonMap[] | undefined;

  public cycleWeekType: CycleWeekType[] | undefined;

  public isStepperVisible: boolean = true;

  public accessOption: AccessOptions | undefined;

  constructor(
    private matDialog: MatDialog,
    private errorService: ErrorService,
    private cycleService: CycleService,
    public configurationService: ConfigurationService,
    private profileService: ProfileService,
    public dialog: MatDialog,
    private utilisService: UtilisService,
    private reasonService: ReasonService,
    private userService: UserService,
    private popupManagerService: PopupManagerService,
    public formBuilder: FormBuilder,
    private hrSuiteService: HrsuiteService,
    private reasonsMapsService: ReasonMapService,
    private router: Router,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    moment.locale('fr');
    this.accessOption = this.userService.getAccessOptionsOfPage(this.router.url);
    this.day = this.getOneWeekFromToday();
    this.weekDays = this.getDateWeekDays(this.day);
    this.shortDates = this.getShortDates(this.weekDays);
    this.showAllRooms = true;
    this.isInfoLoading = [false, false, false, false, false];
    this.pageSize = Math.round(window.innerHeight / 100);
    this.nurseCycleEffectif = [];
    this.anesthCycleEffectif = [];
    this.cycles = [];
    this.hospitalNames = this.userService.getHospitalNames();
  }

  // replace ngOnInit
  async initialize() {
    this.setLoading(true);
    this.isMultiHospitals = this.userService.isCurrentUserHasMultipleHospitalsSelected();
    this.profileList.filterPredicate = (data: Profile, filter: string) => {
      if (!filter || filter.length === 0) {
        return true;
      }

      const filterWithEscapeCharacters = escapeRegExp(filter);
      const filterRegEx = new RegExp(filterWithEscapeCharacters, 'ig');
      if (
        filterRegEx.test(`${data.firstName} ${data.lastName}`) ||
        filterRegEx.test(`${data.lastName} ${data.firstName}`)
      ) {
        return true;
      }

      return false;
    };
    this.type = (await this.userService.isUserInIades())
      ? 'Iade'
      : (await this.userService.isUserInAnesthesistes())
        ? ANESTHETIST
        : NURSE;
    this.profileList.data = [];

    this.absenceReasons = JSON.parse(JSON.stringify(ABSENCE_REASONS));
    this.presenceReasons = JSON.parse(JSON.stringify(PRESENCE_REASONS));
    this.absenceReasons?.splice(4, 1);
    this.presenceReasons?.splice(2, 1);
    await Promise.all([this.getReasons(), this.getReasonsMaps(), this.getReasonsGarde()]);

    if (this.cycle) {
      if (this.isNight) {
        this.getCycleNightEffectifNeeds();
      }
    }

    this.subscribeToCycleChanges();
    this.subscribeToIsNightChanges();
  }

  //common functions
  getCycleNightEffectifNeeds() {
    if (!this.cycle?._id) {
      return;
    }

    this.subscriptionManager
      .createRequest(
        this.cycleService.getCycleNightEffectifNeeds(this.cycle._id),
        'getCycleNightEffectifNeeds',
        this.instanceId
      )
      .subscribe({
        next: (res: any) => {
          this.cycleNightEffectifNeeds = res;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  subscribeToIsNightChanges() {
    this.subscriptionManager
      .createRequest(this.hrSuiteService.toggleNightSubject, 'toggleNightSubject', this.instanceId)
      .subscribe({
        next: (value: boolean) => {
          this.isNight = value;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  //triggers
  setLoading(value: boolean) {
    this.loadingSubject.next(value);
  }

  subscribeToCycleChanges(): void {
    this.subscriptionManager
      .createRequest(this.configurationService.CycleNurseBehaviorSubject, 'CycleNurseBehaviorSubject', this.instanceId)
      .subscribe({
        next: (value: any) => {
          if (value) {
            this.cycle = value;
            this.profileList.data = [];
            this.isCycles = true;
            this.setLoading(false);
            this.cycleDurations = Array.from(Array(this.cycle?.weeks ?? 0), (_: any, i: number) => i + 1);
          } else if (value === null) {
            this.setLoading(false);

            this.profileList.data = [];
            this.isCycles = false;
          }
          this.setCycle(this.cycle);
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getReasonsGarde() {
    return new Promise<void>((resolve: () => void, reject: () => void) => {
      this.subscriptionManager
        .createRequest(this.reasonService.getReason(true), 'getReason', this.instanceId)
        .subscribe({
          next: async (res: any) => {
            if (res && res[0]?.reasons) {
              const allReasons = res[0].reasons;

              const filteredReasons = await Promise.all(
                allReasons.map(async (reason: any) => {
                  if (await this.userService.isUserInIades()) {
                    return (await this.userService.doesAccessOptionHaveIades({ positions: reason.postes }))
                      ? reason
                      : null;
                  } else if (await this.userService.isUserInAnesthesistes()) {
                    return (await this.userService.doesAccessOptionHaveAnesthesistes({ positions: reason.postes }))
                      ? reason
                      : null;
                  } else {
                    return (await this.userService.doesAccessOptionHaveNurses({ positions: reason.postes }))
                      ? reason
                      : null;
                  }
                })
              );

              this.reasonsGarde = filteredReasons.filter(Boolean);

              const grouped: any[] = [];

              this.reasonsGarde.forEach((reasonGarde: any) => {
                const existing = grouped.find((g: any) => g._id === reasonGarde.hospital);
                if (existing) {
                  existing.reasons.push(reasonGarde);
                } else {
                  grouped.push({
                    _id: reasonGarde.hospital,
                    reasons: [reasonGarde],
                  });
                }
              });

              this.reasonsGarde = grouped;
            }

            resolve();
          },
          error: (error: any) => {
            this.errorService.handleError(error);
            reject();
          },
        });
    });
  }

  getReasons() {
    return new Promise<void>((resolve: () => void, reject: () => void) => {
      this.subscriptionManager
        .createRequest(this.reasonService.getAllReasons(), 'getAllReasons', this.instanceId)
        .subscribe({
          next: (res: any) => {
            const sortedReasons: any[] = [];

            res.forEach((reason: any) => {
              if (reason.title !== 'Extraclinique') {
                this.allReasons.push(reason);
              }
              if (sortedReasons.length === 0) {
                sortedReasons.push({
                  _id: reason.hospital,
                  reasons: [reason],
                });
              } else {
                const reasons = sortedReasons.find((reasons_: any) => reasons_._id === reason.hospital);
                if (reasons) {
                  reasons.reasons.push(reason);
                } else {
                  sortedReasons.push({
                    _id: reason.hospital,
                    reasons: [reason],
                  });
                }
              }
            });
            this.reasonsSubject.next(sortedReasons);
            resolve();
          },
          error: (error: any) => {
            this.errorService.handleError(error);
            reject();
          },
        });
    });
  }

  getReasonsMaps() {
    return new Promise<void>((resolve: () => void, reject: () => void) => {
      this.subscriptionManager
        .createRequest(
          this.reasonsMapsService.getSuggestedReasonsMaps(true),
          'getSuggestedReasonsMaps',
          this.instanceId
        )
        .subscribe({
          next: (res: any) => {
            this.reasonsMaps = res;
            this.reasonMapsSubject.next(res);

            resolve();
          },
          error: (error: any) => {
            this.errorService.handleError(error);
            reject();
          },
        });
    });
  }

  getShortDate(date: string): string {
    const momentDate = moment.utc(date);
    return momentDate.format('DD MMM');
  }

  getShortDates(dates: string[]): string[] {
    const shortDates: string[] = [];
    for (const date of dates) {
      const shortDate = this.getShortDate(date);
      shortDates.push(shortDate);
    }
    return shortDates;
  }

  getOneWeekFromToday(): moment.Moment {
    const momentDate: moment.Moment = moment.utc();
    return momentDate;
  }

  getProfileList() {
    if (!this.type) {
      return;
    }
    this.subscriptionManager
      .createRequest(
        this.profileService.getProfilesByPosition(this.type, this.page, this.pageSize, this.searchValue, true, true),
        'getProfilesByPosition',
        this.instanceId
      )
      .subscribe({
        next: (res: any) => {
          this.profileList.filter = '';
          this.profileList.data = res.docs;
          this.selectedDays = [...Array(this.profileList.data.length)].map(() => []);
        },
        error: (error: any) => {
          this.setLoading(false); // Partage la valeur via le service

          this.errorService.handleError(error);
        },
      });
  }

  getDateWeekDays(definedDate: any): string[] {
    const date: moment.Moment = moment.utc(definedDate);
    const days: string[] = [];
    const startOfWeek = moment.utc(date).startOf('isoWeek');
    const endOfWeek = moment.utc(date).endOf('isoWeek');
    let day = startOfWeek;
    while (day <= endOfWeek) {
      days.push(day.toISOString(true));
      day = day.clone().add(1, 'd');
    }
    return days;
  }

  checkConflictsAndGenerateCalendars() {
    if (this.profileList.data.length === 0) {
      return;
    }

    const dialogRef = this.dialog.open(ProfilesSelectionGenerationComponent, {
      width: '1280px',
      data: {
        profiles: this.profileList.data,
        withTypes: true,
        title: `Génération de ${this.hospitalNames.cyclesName.toLowerCase()}s`,
        generateBtnTitle: `Générer les ${this.hospitalNames.cyclesName.toLowerCase()}s`,
        showWeekDatepicker: true,
        cycleWeeks: this.cycleDurations,
        comments: this.cycle?.commentsByWeek,
      },
    });

    this.subscriptionManager
      .createRequest(dialogRef.afterClosed(), 'ProfilesSelectionGenerationPopup', this.instanceId)
      .subscribe({
        next: (result: any) => {
          if (result) {
            this.startDate = result.startDate;
            this.endDate = result.endDate;
            this.keepOldCalendars = result.type;
            this.startingWeekNumber = result.startingWeekNumber;

            if (this.startDate && this.endDate) {
              if (this.keepOldCalendars && this.cycle) {
                this.subscriptionManager
                  .createRequest(
                    this.cycleService.checkConflicts(
                      this.dateToString(this.startDate),
                      this.dateToString(this.endDate),
                      this.cycle
                    ),
                    'checkConflicts',
                    this.instanceId
                  )
                  .subscribe({
                    next: (conflicts: any) => {
                      if (conflicts.length === 0) {
                        this.generateProfiledCalendars(result.profiles);
                      } else {
                        this.showPopupConfirmation(result.profiles);
                      }
                    },
                    error: (error: any) => this.errorService.handleError(error),
                  });
              } else {
                this.generateProfiledCalendars(result.profiles);
              }
            }
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  showPopupConfirmation(profiles: string[]) {
    const title = 'Générer le roulement ?';
    const description = `Le planning de présence sera modifié sur la période selon le roulement configuré.<br> Les vacances et les absences justifiées seront conservées par la génération du roulement.<br>  Les gardes déjà renseignées seront conservées sur la période.`;

    this.subscriptionManager
      .createRequest(
        this.popupManagerService
          .openConfirmationPopup(title, description, 570, 'primary', 'Oui, générer')
          .afterClosed(),
        'ConfirmationPopup',
        this.instanceId
      )
      .subscribe({
        next: (result: any) => {
          if (result) {
            this.generateProfiledCalendars(profiles);
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  generateCalendars(): void {
    if (!this.startDate || !this.endDate || !this.cycle) {
      return;
    }

    this.subscriptionManager
      .createRequest(
        this.cycleService.generateCalendars(
          this.dateToString(this.startDate),
          this.dateToString(this.endDate),
          this.cycle,
          this.keepOldCalendars
        ),
        'generateCalendars',
        this.instanceId
      )
      .subscribe({
        error: (error: any) => this.errorService.handleError(error),
      });
  }

  generateProfiledCalendars(profileIds: string[]): void {
    if (!this.startDate || !this.endDate || !this.cycle || !this.startingWeekNumber) {
      return;
    }

    this.subscriptionManager
      .createRequest(
        this.cycleService.generateProfiledCalendars(
          this.dateToString(this.startDate),
          this.dateToString(this.endDate),
          this.cycle,
          this.keepOldCalendars,
          profileIds,
          this.startingWeekNumber
        ),
        'generateProfiledCalendars',
        this.instanceId
      )
      .subscribe({
        next: () => {
          this.utilisService.displaySuccessToast('Génération des roulements en cours');
        },
        error: (error: any) => this.errorService.handleError(error),
      });
  }

  dateToString(date: Date): string {
    return moment(date).format('YYYY-MM-DD').toString();
  }

  updateCycle(cycleId: string, template: any) {
    const confirmationPopup = this.dialog.open(ConfirmationPopupComponent, {
      width: '404px',
      data: {
        title: 'Mise à jour du roulement',
        description: 'Voulez-vous mettre à jour ce roulement sur la base de la dernière version du TVO ?',
        generateBtnTitle: 'Mettre à jour',
      },
    });

    this.subscriptionManager
      .createRequest(confirmationPopup.afterClosed(), 'ConfirmationPopup', this.instanceId)
      .subscribe({
        next: (confirmation: any) => {
          if (confirmation) {
            this.progress = 0;
            const dialogRef = this.dialog.open(template, {
              width: '240px',
              disableClose: true,
            });

            this.isGenerating = true;
            this.interval = setInterval(() => {
              if (this.progress < 96) {
                this.progress += 1.6667;
              } else {
                this.progress = 99;
                clearInterval(this.interval);
              }
            }, 1000);

            this.subscriptionManager
              .createRequest(
                this.cycleService.updateOptimCycle(cycleId, this.isNight),
                'updateOptimCycle',
                this.instanceId
              )
              .subscribe({
                next: () => {
                  this.utilisService.displaySuccessToast('Roulement mis à jour.');
                  clearInterval(this.interval);
                  dialogRef.close();
                  this.isGenerating = false;
                  this.configurationService.RefreshNurseCycleBehaviorSubject.next({ refresh: true });
                },
                error: (error: any) => {
                  clearInterval(this.interval);
                  this.errorService.handleError(error);
                  this.isGenerating = false;
                  dialogRef.close();
                },
              });
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getCycles() {
    this.subscriptionManager
      .createRequest(
        this.cycleService.getCycles(this.accessOption?.typeOfCycles, this.isNight),
        'getCycles',
        this.instanceId
      )
      .subscribe({
        next: (res: any) => {
          if (this.accessOption?.seniority?.length === 1 && this.accessOption?.seniority?.includes('Interne')) {
            this.cycles = res.filter((elt: any) => elt.isInterne);
          } else {
            this.cycles = res;
          }
        },
        error: (error: any) => this.errorService.handleError(error),
      });
  }

  generateEffectifForNullCycle(): NurseCycleEffectif[] {
    const nurseCycleEffectif = [];
    for (let i = 0; i < 7; i++) {
      nurseCycleEffectif.push({
        morningNurseEffectif: 0,
        afternoonNurseEffectif: 0,
      });
    }
    return nurseCycleEffectif;
  }

  generateEffectifForNullCycleAnesth(): any[] {
    const anesthCycleEffectif = [];
    for (let i = 0; i < 7; i++) {
      anesthCycleEffectif.push({
        bloc: 0,
        consultation: 0,
      });
    }
    return anesthCycleEffectif;
  }

  setCycle(cycle: cycle | undefined) {
    this.cycle = cycle;
    if (this.cycle) {
      if (this.isNight) {
        this.getCycleNightEffectifNeeds();
      }
      this.cycleDuration = cycle!.weeks;
      this.profileList.data = cycle!.profiles as Profile[];
      this.selectedDays = [...Array(this.profileList.data.length)].map(() => []);
      this.cycleDurations = Array.from(Array(this.cycle.weeks), (_: any, i: number) => i + 1);
    } else {
      this.cycleDuration = 1;
      this.getProfileList();
    }
  }

  deleteCycle() {
    if (!this.cycle) {
      return;
    }
    const title = 'Supprimer le roulement ?';
    // const description = `Etes vous sûr(e) de vouloir roulement le cycle ${this.cycle.name} ?`;
    const description = `Etes-vous sûr(e) de vouloir supprimer le roulement ${this.cycle.name}`;

    this.subscriptionManager
      .createRequest(
        this.popupManagerService.openConfirmationPopup(title, description, 0, 'danger', 'Oui, supprimer').afterClosed(),
        'deleteCycle',
        this.instanceId
      )
      .subscribe({
        next: (result: any) => {
          if (result) {
            this.profileList.data = [];
            this.subscriptionManager
              .createRequest(this.cycleService.deleteCycle(this.cycle!), 'deleteCycle', this.instanceId)
              .subscribe({
                next: () => {
                  this.utilisService.displaySuccessToast('Roulement supprimé.');
                  this.configurationService.RefreshNurseCycleBehaviorSubject.next({ refresh: true });
                },

                error: (error: any) => {
                  this.errorService.handleError(error);
                },
              });
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  openProfilesPopup() {
    if (this.cycle !== undefined && (this.cycle.position === ANESTHETIST || this.cycle.position === 'Iade')) {
      this.position = this.cycle.position;
    } else {
      this.position = this.type;
    }
    //open popup
    const dialogRef = this.matDialog.open(ProfilesPickerDialogComponent, {
      width: '1200px',
      height: '60%',
      data: {
        selectedProfiles: this.cycle?.profiles,
        type: this.type,
        position: this.position,
        cycle: this.cycle,
        isNight: this.isNight,
      },
    });

    this.subscriptionManager.createRequest(dialogRef.afterClosed(), 'openProfilesPopup', this.instanceId).subscribe({
      next: (res: any) => {
        if (res) {
          this.editCycle(res);
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }

  editCycle(cycle: cycle) {
    if (!this.cycle) {
      return;
    }
    this.profileList.data = cycle.profiles as Profile[];
    this.selectedDays = [...Array(this.profileList.data.length)].map(() => []);
    this.cycle.profiles = cycle.profiles;
    this.cycle.name = cycle.name;
    this.cycle.seniorities = cycle.seniorities;
    this.subscriptionManager
      .createRequest(this.cycleService.editCycle(this.cycle), 'editCycle', this.instanceId)
      .subscribe({
        next: () => {
          this.configurationService.CycleNurseBehaviorSubject.next(this.cycle);
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  openPopup(): void {
    const dialogRef = this.dialog.open(CreateCycleDialogComponent, {
      width: '1200px',
      height: '60%',
      data: {
        type: this.type,
        isNight: this.isNight,
      },
    });

    this.subscriptionManager.createRequest(dialogRef.afterClosed(), 'createCycle', this.instanceId).subscribe({
      next: (result: any) => {
        if (result) {
          this.configurationService.RefreshNurseCycleBehaviorSubject.next({ refresh: true });
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }
}
